export default __webpack_public_path__ + "eye-closed.bdeb06e58a5192c6374a76cba0fbcca4.png";